module.exports = __webpack_public_path__ + "static/media/integracao.c19eb032.png";